// imports
import { strToDom } from 'minsky-kit/js/utils/dom';

/* MoveEl and leave a crumb
    $el: element to move
    $target: $target to move it to
    $type: append (use $target as parent), before or after

    Every time the element is moved, it will leave a span with id as crumb
    Crumb ids will be collected in a data attribute for easy reset later on.
*/
export function removeElWithCrumb ($el) {
    const id = Math.round(Math.random() * Math.random() * 1000000000).toString(16);
    const $crumb = strToDom(`<span id="crumb-${id}"></span>`);

    // insert crumb right before $el
    $el.parentNode.insertBefore($crumb, $el);
    $el.remove();

    // keep id as data element for easy crumb retrieval
    if (!$el.dataset.crumbs) $el.dataset.crumbs = '';
    $el.dataset.crumbs = (($el.dataset.crumbs !== '') ? '|' : '') + id;

    return $el;
}

/* Reset el to crumb position
    $el: element to move
    $targetParent: element to look into for the crumb (default: document.body)

    Target Parent can be used to target elements that aren't present in the dom
*/
export function resetElToCrumb ($el, $targetParent = null) {
    // default to body
    if (!$targetParent) $targetParent = document.body;

    // extract crumb id
    const crumbs = $el.dataset.crumbs.split('|');
    const id = (crumbs.length && crumbs[0] !== '') ? crumbs.pop() : null;

    // only continue if we have a crumb id
    if (id !== null) {
        // look for crumb
        const $crumb = $targetParent.querySelector(`#crumb-${id}`);

        // if crumb is found, do the switcheroo & update dataset
        if ($crumb) {
            $crumb.parentNode.insertBefore($el, $crumb);
            $crumb.remove();

            if (crumbs.length) {
                $el.dataset.crumbs = crumbs.join('|');
            }
            else {
                delete $el.dataset.crumbs;
            }

            return true;
        }
    }

    return false;
}
